import React, { Component } from "react";
import { Route } from "react-router-dom";

import "./Theme/variables.css";

import LogInScreen from "./Components/Container/LogInScreen";
import MainScreen from "./Components/Container/MainScreen";
import ProfileScreen from "./Components/Container/ProfileScreen";
import ItemScreen from "./Components/Container/ItemScreen";
import ReportScreen from "./Components/Container/ReportScreen";

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "GreenCobra",
    };
  }

  render() {
    return (
      <div className="App">
        <header className="App-header">
          <Route exact path="/" render={() => <LogInScreen />} />
          <Route path="/MainScreen" render={() => <MainScreen />} />
          <Route path="/ProfileScreen" render={() => <ProfileScreen />} />
          <Route path="/ReportScreen" render={() => <ReportScreen />} />
          <Route
            path="/ItemScreen/:id"
            render={(props) => <ItemScreen {...props} />}
          />
        </header>
      </div>
    );
  }
}

export default App;
